import { computed, Injectable } from '@angular/core';
import { AppPayment } from '@models/api-calls/payment/payment.model';
import { ApplicationService } from '@services/api-calls/application.service';
import { PaymentMappingService } from '@services/api-calls/payment-mapping.service';
import { PaymentStatusEnum } from 'app/enums/form/form.enum';
import isEqual from 'lodash-es/isEqual';

@Injectable({
    providedIn: 'root',
})
export class PaymentDataService {
    constructor(
        private applicationService: ApplicationService,
        private paymentMappingService: PaymentMappingService,
    ) {}

    applicationPayment = computed<AppPayment | null>(
        () => {
            const rawApplication = this.applicationService.rawApplication();
            if (!rawApplication?.app_payment) {
                return null;
            }
            return this.paymentMappingService.mapAppPaymentResponseToAppPayment(rawApplication.app_payment);
        },
        { equal: (a, b) => isEqual(a, b) },
    );

    hasPrimaryPaymentData = computed(() => {
        const appPayment = this.applicationPayment();
        if (!appPayment) return false;
        return !!(
            appPayment.primary_payer ||
            appPayment.primary_payer_id ||
            appPayment.primary_payment_method ||
            appPayment.primary_payment_status ||
            appPayment.primary_payment_verification
        );
    });

    primaryPaymentFailed = computed(() => {
        const appPayment = this.applicationPayment();
        return appPayment?.primary_payment_status === PaymentStatusEnum.FAILED;
    });

    secondaryPaymentFailed = computed(() => {
        const appPayment = this.applicationPayment();
        return appPayment?.secondary_payment_status === PaymentStatusEnum.FAILED;
    });
}
